var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccessRatesIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 45 45",
    width: 50,
    height: 50,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    fill: "#011b33"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.588 13.397l-1.313.7-5.312 4.282-8.531 6.656-2.75-2.969-8.5 6.094-1.475 1.428a.38.38 0 0 0 .073.06c.002 0 .183.113.427.276l.261.178c.136.094.274.196.406.297a2.874 2.874 0 0 1 .475.42 4.4 4.4 0 0 1 .13.178c.097.14.205.307.31.472.264.42.506.84.508.842a.357.357 0 0 0 .052.07.673.673 0 0 0 .49.212.628.628 0 0 0 .358-.11.643.643 0 0 0 .107-.075l5.9-5.58 2.334 2.49a1.865 1.865 0 0 0 1.606.564c.007 0 .082-.016.089-.017a1.86 1.86 0 0 0 .908-.446l9.038-8.546.587 2.184a.62.62 0 0 0 .599.463h.009a.62.62 0 0 0 .601-.451l2.7-9.31a.374.374 0 0 0-.087-.362z",
    fill: "#00e1ff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.474 29.746l6.873-6.561 3.61 3.703 14.63-13.491a.378.378 0 0 0-.356-.108l-9.335 2.174a.647.647 0 0 0-.373.24.667.667 0 0 0-.135.385.651.651 0 0 0 .477.65l1.84.529-6.665 6.084-2.338-2.494a1.853 1.853 0 0 0-1.61-.566 1.862 1.862 0 0 0-.995.464l-8.37 7.947a.627.627 0 0 0-.02.886l2.662.158z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessRatesIcon);
export default __webpack_public_path__ + "static/media/Success-rates-icon.4f4f14fdc82f2a3edc8a526e993cb59f.svg";
export { ForwardRef as ReactComponent };